<template>
  <div class="modal fade" id="subscriberModal" tabindex="-1" data-bs-keyboard="false"
       data-bs-backdrop="static">
    <div class="modal-dialog modal-lg" style="max-width: 90%;">
      <div class="modal-content" :key="uniqueKey">

        <div class="modal-header">
          <h5 class="modal-title">
            {{ isEditMode ? 'Editar Assinatura' : 'Nova Assinatura' }}
          </h5>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>

        <div class="modal-body">
          <div v-if="companyName" class="d-flex align-items-center bg-light-primary rounded p-3 mb-4">
            <i class="bi bi-building fs-4 text-primary me-3"></i>
            <div>
              <span class="text-muted small">Empresa</span>
              <div class="fw-bold text-dark">{{ companyName }}</div>
            </div>
          </div>

          <form @submit.prevent="submit">
            <!-- Seção: Plano -->
            <div class="row mb-4">
              <div class="col-md-12">
                <h6 class="text-muted mb-3 fw-bold">PLANO</h6>
                <label class="form-label required">Plano</label>
                <select v-model="form.id_plan" class="form-control form-control-solid" required :disabled="isEditMode" @change="onSelectPlan($event.target.value)">
                  <option :value="plan.id_plan" :key="plan.id_plan" v-for="plan in getPlans()">
                    {{plan.plan_name}}
                  </option>
                </select>

                <div class="alert alert-primary mt-3" role="alert" v-if="selectedPlan?.id_plan">
                  <strong>{{ selectedPlan.plan_name }}</strong>: {{ selectedPlan.plan_description }} <br>
                  <small>
                    Duração: {{ selectedPlan.subscriber_duration }} meses |
                    Valor: R$ {{ selectedPlan.plan_base_price }}
                    <span v-if="selectedPlan.plan_dependent_price > 0">
                      + R$ {{ selectedPlan.plan_dependent_price }} por
                      dependente
                    </span>
                  </small>
                </div>
              </div>
            </div>

            <hr class="my-4">

            <!-- Seção: Dados do Titular -->
            <div class="row mb-4">
              <div class="col-md-12">
                <h6 class="text-muted mb-3 fw-bold">DADOS DO TITULAR</h6>
              </div>
              <div class="col-md-3">
                  <label class="fs-6 fw-bold required mb-2">Paciente</label>
                  <SearchPatient v-model="form.user_name" :disabled="subscriberId != null"
                                 :key="subscriberId + '-' + uniqueKey"
                                 @onInput="onClickSearchedPatient"
                                 @onClick="onClickSearchedPatient"
                  />
              </div>

              <div :class="form.is_foreign ? 'col-md-6' : 'col-md-2'">
                  <PatientIdentityFields :form="form" cpf-field="user_cpf" :disabled="subscriberId != null" :allow-select="!subscriberId" @select="onClickSearchedPatient" />
              </div>

              <div class="col-md-2">
                  <label class="fs-6 required fw-bold mb-2">Data Nascimento</label>
                  <input type="text" class="form-control form-control-solid"
                         v-mask="'##/##/####'" required :disabled="subscriberId != null"
                         placeholder="DD/MM/YYYY" v-model="form.user_dt_birth"/>
              </div>

              <div class="col-md-2">
                  <label class="fs-6 required fw-bold mb-2">Telefone</label>
                  <input type="text" class="form-control form-control-solid"
                         v-mask="['(##) ####-####', '(##) #####-####']" required
                         placeholder="(99) 9 9999-9999" v-model="form.user_phone"/>
              </div>

              <div class="col-md-3">
                  <label class="fs-6 required fw-bold mb-2">E-mail</label>
                  <input type="email" class="form-control form-control-solid"
                         required
                         placeholder="email@exemplo.com" v-model="form.user_email"/>
              </div>
            </div>

            <hr class="my-4">

            <!-- Seção: Endereço -->
            <div class="row mb-4">
              <div class="col-md-12">
                <h6 class="text-muted mb-3 fw-bold">ENDEREÇO</h6>
              </div>
              <div class="col-md-2">
                <label class="fs-6 required fw-bold mb-2">CEP</label>
                <input type="text" class="form-control form-control-solid"
                       v-mask="['#####-###']" required @change="getZipCode($event.target.value)"
                       placeholder="Ex. 13666-655" v-model="form.user_addr_zipcode"/>
              </div>
              <div class="col-md-5">
                <label class="fs-6 required fw-bold mb-2">Endereço</label>
                <input type="text" class="form-control form-control-solid"
                       maxlength="255"
                       required placeholder="Ex. Rua Coronel Santos" v-model="form.user_address"/>
              </div>
              <div class="col-md-2">
                <label class="fs-6 required fw-bold mb-2">Número</label>
                <input type="text" class="form-control form-control-solid" ref="user_addr_numer"
                       maxlength="20"
                       required placeholder="Ex. 150" v-model="form.user_addr_numer"/>
              </div>
              <div class="col-md-3">
                <label class="fs-6 fw-bold mb-2">Complemento</label>
                <input type="text" class="form-control form-control-solid"
                       maxlength="150"
                       placeholder="Ex. Apto 10, bloco 2" v-model="form.user_addr_compl"/>
              </div>
              <div class="col-md-4">
                <label class="fs-6 required fw-bold mb-2">Bairro</label>
                <input type="text" class="form-control form-control-solid"
                       maxlength="50"
                       required placeholder="Ex. Centro" v-model="form.user_neighborhood"/>
              </div>
              <div class="col-md-4">
                <label class="required form-label">Estado</label>
                <DropdownUbbi
                  :showClear="true"
                  :options="states"
                  :filter="true"
                  appendTo="self"
                  @change="getCitiesFromState($event.value)"
                  v-model="form.id_state"
                  optionLabel="state_name"
                  optionValue="id_state"
                  placeholder="Selecione o estado"
                />
              </div>
              <div class="col-md-4">
                <label class="fs-6 required fw-bold mb-2">Cidade</label>
                <DropdownUbbi
                  :showClear="true"
                  :options="citiesFromState"
                  :filter="true"
                  appendTo="self"
                  v-model="form.id_city"
                  optionLabel="city_name"
                  optionValue="id_city"
                  placeholder="Selecione a cidade"
                />
              </div>
            </div>

            <hr class="my-4">

            <!-- Seção: Configuração da Assinatura -->
            <div class="row mb-4">
              <div class="col-md-12">
                <h6 class="text-muted mb-3 fw-bold">CONFIGURAÇÃO DA ASSINATURA</h6>
              </div>
              <div class="col-md-3">
                <label class="form-label required">Forma de Pagamento</label>
                <select v-model="form.plan_payment_method" class="form-control form-control-solid" required @change="onPlanPaymentMethodChange">
                  <option :value="paymentMethod.id"
                          :key="paymentMethod.id" v-for="paymentMethod in this.getPaymentMethods()">
                    {{paymentMethod.name}}
                  </option>
                </select>
              </div>

              <div class="col-md-3">
                <label class="form-label required">Modo de Cobrança</label>
                <select v-model="form.billing_mode" class="form-control form-control-solid" required :disabled="isEditMode">
                  <option value="upfront">Tudo de uma vez</option>
                  <option value="monthly">Mensal</option>
                </select>
              </div>

              <div class="col-md-3">
                <label class="form-label">Dependentes Gratuitos</label>
                <input type="number" class="form-control form-control-solid" v-model="form.subs_free_dependents" min="0" :disabled="isEditMode"/>
              </div>

              <div class="col-md-3">
                <label class="form-label required">Status</label>
                <select v-model="form.subs_status" class="form-control form-control-solid" required disabled>
                  <option :value="status" :key="status" v-for="(statusDsc, status) in subscribersStatus">
                    {{statusDsc}}
                  </option>
                </select>
              </div>

              <div class="col-md-4">
                <label class="form-label required">Primeiro Vencimento</label>
                <Calendar class="form-control form-control-sm" @dateSelect="getPreviewCharges"
                          :min-date="minDateToday" dateFormat="dd/mm/yy" v-model="form.first_date_due" :disabled="isEditMode"/>
              </div>

              <div class="col-md-4">
                <label class="form-label required">Data de Início</label>
                <Calendar class="form-control form-control-sm"
                          :min-date="new Date()" dateFormat="dd/mm/yy" 
                          v-model="form.start_date"
                          :disabled="isEditMode"/>
              </div>

              <div class="col-md-4">
                <label class="form-label required">Data de Término</label>
                <Calendar class="form-control form-control-sm"
                          dateFormat="dd/mm/yy" 
                          v-model="form.end_date"
                          :disabled="isEditMode"/>
              </div>

              <div class="col-md-12 mt-3" v-show="selectedPlan?.id_plan">
                <button class="btn btn-primary btn-sm" type="button" data-bs-toggle="collapse" id="BtnCollapseSelectedPlan"
                        data-bs-target="#collapseSelectedPlan" aria-expanded="false" aria-controls="collapseSelectedPlan">
                  Alterar valores
                </button>
                <button class="btn btn-success btn-sm ms-2" type="button" @click="exportCard()" title="Exportar cartão do titular" v-if="isEditMode">
                  <i class="bi bi-credit-card"></i> Exportar Cartão
                </button>
              </div>

              <div class="collapse" id="collapseSelectedPlan">

                <div class="row">
                  <div class="col-md-3">
                    <label class="form-label">Valor: </label>
                    <money3 @change="getPreviewCharges"
                      class="form-control form-control-solid"
                      v-model="form.subs_base_price"
                      v-bind="config"
                      :disabled="isEditMode">
                    </money3>
                  </div>

                  <div class="col-md-3">
                    <label class="form-label">Valor por dependente</label>
                    <money3 @change="getPreviewCharges"
                      class="form-control form-control-solid"
                      v-model="form.subs_dependent_price"
                      v-bind="config"
                      :disabled="isEditMode">
                    </money3>
                  </div>
                </div>
              </div>

              <!-- Contrato vinculado ao plano -->
              <div class="col-md-12 mt-3" v-if="selectedPlan?.contract_template && !isEditMode">
                <div class="card border border-primary">
                  <div class="card-header bg-light-primary">
                    <h6 class="card-title mb-0">
                      <i class="bi bi-file-earmark-text me-2 text-primary"></i>
                      Contrato: {{ selectedPlan.contract_template.template_name }}
                    </h6>
                  </div>
                  <div class="card-body py-3">
                    <p class="mb-2 text-muted small">
                      Este plano possui um modelo de contrato vinculado. O contrato será gerado automaticamente
                      após a criação da assinatura.
                    </p>
                    <button type="button" class="btn btn-sm btn-primary" @click="previewContract"
                            :disabled="!form.user_name">
                      <i class="bi bi-eye me-1"></i>
                      Pré-visualizar Contrato
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <hr>

            <div v-if="selectedPlan?.id_plan && allowsDependents">
              <div class="col-md-12">
                <h1>Dependentes</h1>
                <p v-if="contractedDependentHint" class="text-muted small mb-2">{{ contractedDependentHint }}</p>
                <button type="button" class="btn btn-sm btn-primary" @click="addNewDependent()" 
                        :disabled="!canAddMoreDependents">
                  Novo Dependente
                </button>
                <p v-if="allowsDependents" class="text-muted small mt-2 mb-0">
                  Dependentes ativos:
                  <strong>{{ activeNonMainDependentsCount }}</strong>
                  de
                  <strong>{{ dependentMaxDisplay }}</strong>
                </p>
              </div>
              <div class="row" v-for="(dependent, index) in form.dependents" :key="index">
                <div class="col-md-3">
                  <label class="fs-6 fw-bold required mb-2">Paciente</label>
                  <SearchPatient v-model="dependent.user_name"
                                 :idFather="dependent.patient_cpf"
                                 :key="dependent.patient_cpf + '-' + uniqueKey + '-' + index"
                                 @onInput="onClickSearchedPatient($event, index)"
                                 @onClick="onClickSearchedPatient($event, index)"
                  />
                </div>

                <div :class="dependent.is_foreign ? 'col-md-6' : 'col-md-2'">
                  <PatientIdentityFields :form="dependent" cpf-field="user_cpf" allow-select @select="onClickSearchedPatient($event, index)" />
                </div>

                <div class="col-md-2">
                  <label class="fs-6 required fw-bold mb-2">Data Nascimento</label>
                  <input type="text" class="form-control form-control-solid"
                         v-mask="'##/##/####'" required
                         placeholder="DD/MM/YYYY" v-model="dependent.user_dt_birth"/>
                </div>

                <div class="col-md-2">
                  <label class="fs-6 required fw-bold mb-2">Telefone</label>
                  <input type="text" class="form-control form-control-solid"
                         v-mask="['(##) ####-####', '(##) #####-####']"
                         placeholder="(99) 9 9999-9999" v-model="dependent.user_phone"/>
                </div>
                <div class="col-md-1">
                  <label class="fs-6 fw-bold mb-2">Parentesco</label>
                  <input type="text" class="form-control form-control-solid"
                         placeholder="Ex. filho" v-model="dependent.dep_relationship"/>
                </div>
                <div class="col-md-2">
                  <label class="fs-6 fw-bold mb-2 d-block">&nbsp;</label>
                  <button class="btn btn-success" title="Exportar cartão do dependente" type="button" @click="exportCard(dependent.id_dependent)" v-if="isEditMode">
                    <i class="bi bi-credit-card"></i>
                  </button>
                  <button class="btn btn-danger ms-1" title="Remover dependente" type="button" @click="removeDependent(index)">
                    <i class="bi bi-trash2"></i>
                  </button>
                </div>
              </div>
              <br>

              <div v-if="!isEditMode">
                <hr>
                <div class="row">
                  <div class="col-md-10">
                    <h1>Cobranças</h1>
                  </div>
                  <div class="col-md-2" v-if="chargesPreview.length > 0">
                    <label>Status Geral</label>
                    <select @change="changeStatusAllCharges($event.target.value)"
                            class="form-control form-control-sm">
                      <option value=""></option>
                      <option :value="status" v-for="(statusDsc, status) in chargesStatuses" :key="status">
                        {{ statusDsc }}
                      </option>
                    </select>
                  </div>
                </div>
                <br>
                <div class="row">
                  <table class="table table-row-bordered border">
                    <thead>
                    <tr>
                      <th>#</th>
                      <th>Valor</th>
                      <th>Vencimento</th>
                      <th>Forma de pagamento</th>
                      <th>Status</th>
                      <th>Referência</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(charge, index) in chargesPreview" :key="'charge' + index">
                      <td>{{ index + 1 }}</td>
                      <td>R$ {{ Number(charge.charge_amount).toFixed(2) }}</td>
                      <td>{{ formatDate(charge.charge_due_date) }}</td>
                      <td>
                        <select class="form-control form-control-sm" v-model="charge.plan_payment_method">
                          <option :value="paymentMethod.id"
                                  :key="paymentMethod.id"
                                  v-for="paymentMethod in getChargePaymentMethods()">
                            {{ paymentMethod.name }}
                          </option>
                        </select>
                      </td>
                      <td>
                        <select class="form-control form-control-sm" v-model="charge.charge_status">
                          <option :value="status" v-for="(statusDsc, status) in chargesStatuses" :key="status">
                            {{ statusDsc }}
                          </option>
                        </select>
                      </td>
                      <td>{{ charge.charge_reference }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button type="submit" class="btn btn-primary">
                {{ isEditMode ? 'Atualizar' : 'Salvar' }}
              </button>
            </div>
          </form>
        </div>

      </div>
    </div>
  </div>

  <!-- Modal de Preview do Contrato -->
  <div class="modal fade" id="contractPreviewModalSubscriber" tabindex="-1">
    <div class="modal-dialog modal-xl" style="max-width: 90%;">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <i class="bi bi-file-earmark-text me-2"></i>
            {{ contractPreviewTitle || 'Pré-visualização do Contrato' }}
          </h5>
          <button type="button" class="btn-close" @click="closeContractPreview"></button>
        </div>

        <div class="modal-body p-0">
          <div class="contract-preview-container p-4" v-html="contractPreviewHtml"></div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeContractPreview">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { patientIdentity, identityError } from '../../helpers/patientIdentity';
import http from "@/helpers/http";
import Modal from "@/helpers/modal";
import Calendar from "primevue/calendar";
import SearchPatient from "@/components/SearchPatient.vue";
import {mask} from "vue-the-mask";
import {Money3} from "v-money3";
import Alert from "@/helpers/alert";
import DropdownUbbi from "@/components/DropdownUbbi.vue";
import Loader from "@/helpers/loader";

export default {
  name: "SubscriberModal",
  props: ['subscriber'],
  emits: ['onClose', 'subscriberSaved'],
  components: {
    DropdownUbbi,
    Money3,
    Calendar,
    SearchPatient,
  },
  directives: {
    mask
  },
  data() {
    return {
      subscriberLocal: null,
      states: [],
      citiesFromState: [],
      plans: [],
      paymentMethods: [],
      subscribersStatus: [],
      chargesPreview: [],
      chargesStatuses: [],
      config: {
        masked: false,
        prefix: 'R$ ',
        suffix: '',
        thousands: '.',
        decimal: ',',
        precision: 2,
        disableNegative: true,
        disabled: false,
        min: null,
        max: null,
        allowBlank: true, 
        minimumNumberOfCharacters: 0,
        shouldRound: false,
        focusOnRight: false,
      },
      form: {
        id_plan: null,
        plan_payment_method: null,
        subs_base_price: 0,
        subs_dependent_price: 0,
        first_date_due: null,
        start_date: null,
        end_date: null,
        subs_status: 'pending',
        billing_mode: null,
        subs_free_dependents: null,
        user_name: null,
        user_cpf: null,
        id_user: null,
        id_patient: null,
        user_phone: null,
        user_email: null,
        user_dt_birth: null,
        user_address: null,
        user_addr_zipcode: null,
        user_addr_numer: null,
        user_addr_compl: null,
        user_neighborhood: null,
        id_city: null,
        id_state: null,
        dependents: []
      },
      subscriberId: null,
      selectedPlan: null,
      uniqueKey: this.date().unix().toString(),
      contractPreviewHtml: null,
      contractPreviewTitle: null,
      pixData: null,
      previousPlanPaymentMethod: null,
    };
  },
  watch: {
    subscriber: {
      immediate: true,
      handler(newValue) {
        this.subscriberLocal = newValue;
        this.populateModal();
        this.uniqueKey = this.date().unix().toString();
      }
    }
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    isEditMode() {
      return this.subscriber !== null;
    },
    companyName() {
      if (!this.subscriberLocal || this.subscriberLocal.subscriber_type !== 'company') return null;
      return this.subscriberLocal.company?.company_name ?? null;
    },
    allowsDependents() {
      if (!this.selectedPlan) return false;

      const dependentPrice = this.selectedPlan.plan_dependent_price;
      const maxDependents = this.selectedPlan.plan_max_dependents;

      if (maxDependents == null) return true;
      
      // Rule 1: If maxDependents is 0, never allow dependents
      if (maxDependents === 0) return false;
      
      // Rule 2: If dependentPrice is null/undefined, no dependents allowed
      if (dependentPrice === null || dependentPrice === undefined) return false;
      
      // Rule 3: If dependentPrice is a valid number >= 0, allow dependents
      const priceNum = parseFloat(String(dependentPrice));
      return !isNaN(priceNum) && priceNum >= 0;
    },
    hasGatewayCharges() {
      const charges = this.subscriberLocal?.charges;
      if (!Array.isArray(charges) || charges.length === 0) {
        return false;
      }
      return charges.some((c) => c.id_card_trans != null && c.id_card_trans !== '');
    },
    /**
     * Teto de vagas de dependentes não-titulares no formulário (criação = só plano; edição = contratual ou plano).
     */
    dependentSlotCap() {
      if (!this.selectedPlan) {
        return 0;
      }
      const planMax = this.selectedPlan.plan_max_dependents;

      if (!this.isEditMode) {
        if (planMax == null) {
          return Infinity;
        }
        return Number(planMax);
      }

      const status = this.form.subs_status || this.subscriberLocal?.subs_status;
      const usesContractualCap = status === 'active' || (status === 'pending' && this.hasGatewayCharges);
      const planCap = planMax == null ? Infinity : Number(planMax);

      if (!usesContractualCap) {
        return planCap;
      }

      const contractualFloor = this.contractualDependentFloor;
      if (contractualFloor == null) {
        return planCap;
      }

      return Math.min(planCap, contractualFloor);
    },
    /**
     * Maior entre dependentes já contratados (snapshot) e vagas gratuitas (assinatura ou plano).
     */
    contractualDependentFloor() {
      const contracted = this.subscriberLocal?.subs_contracted_dependents;
      if (contracted == null || contracted === '') {
        return null;
      }

      const free = Number(
        this.subscriberLocal?.subs_free_dependents
          ?? this.selectedPlan?.plan_free_dependents
          ?? 0,
      );

      return Math.max(Number(contracted), free);
    },
    contractedDependentHint() {
      if (!this.isEditMode || !this.subscriberLocal) {
        return '';
      }
      const status = this.form.subs_status || this.subscriberLocal.subs_status;
      const applies = status === 'active' || (status === 'pending' && this.hasGatewayCharges);
      if (!applies) {
        return '';
      }
      const limit = this.contractualDependentFloor;
      if (limit == null) {
        return '';
      }
      return `Limite contratual: até ${limit} dependente(s) ativo(s) (exceto titular), sem ultrapassar o máximo do plano. Remover da lista apenas desativa o vínculo.`;
    },
    canAddMoreDependents() {
      if (!this.allowsDependents) return false;

      if (this.selectedPlan.plan_max_dependents==null) return true;

      return this.form.dependents.length < this.dependentSlotCap;
    },
    /** Linhas no formulário = dependentes não titulares que permanecem ativos ao salvar. */
    activeNonMainDependentsCount() {
      if (!this.allowsDependents) {
        return 0;
      }
      return this.form.dependents.length;
    },
    /** Texto do teto para o contador (plano / contratual). */
    dependentMaxDisplay() {
      const cap = this.dependentSlotCap;
      if (cap === Infinity) {
        return 'ilimitado (plano)';
      }
      return String(cap);
    },
    /** Início do dia local — comparação estável com PrimeVue Calendar (evita “hoje” inválido por horário). */
    minDateToday() {
      const d = new Date();
      d.setHours(0, 0, 0, 0);
      return d;
    },
  },
  mounted() {
    this.loadPlans();
    this.loadPaymentMethods();
    this.loadSubscriberStatus();
    this.getStates();
    this.getChargesStatus();
    this.loadSubscriptionConfig();
    this.uniqueKey = this.date().unix().toString();
  },
  methods: {
    date: moment,
    formatDate(date) {
      if (!date) return '-';
      return this.date(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    validateFirstDueDateNotBeforeToday() {
      const raw = this.form.first_date_due;
      if (raw == null || raw === '') {
        Alert.error('Informe a primeira data de vencimento.');
        return false;
      }
      let m;
      if (raw instanceof Date) {
        m = this.date(raw);
      } else if (typeof raw === 'string') {
        m = this.date(raw, 'DD/MM/YYYY', true);
      } else {
        m = this.date(raw);
      }
      if (!m.isValid()) {
        Alert.error('Primeira data de vencimento inválida.');
        return false;
      }
      const todayStart = this.date().startOf('day');
      if (m.startOf('day').isBefore(todayStart)) {
        Alert.error('A primeira data de vencimento não pode ser anterior à data de hoje.');
        return false;
      }
      return true;
    },
    getPaymentMethods() {
      if (this.isEditMode) {
        return this.paymentMethods;
      } else {
        const allowed = ['money', 'bank_slip', 'pix'];
        return this.paymentMethods.filter(pm => allowed.includes(pm.id));
      }
    },
    /**
     * Opções por parcela na criação: inclui cartão para parcelas avulsas mesmo quando a assinatura é boleto/pix/dinheiro.
     */
    getChargePaymentMethods() {
      const allowed = ['money', 'bank_slip', 'pix', 'credit_card'];
      return (this.paymentMethods || []).filter(pm => allowed.includes(pm.id));
    },
    getPlans() {
      const data = this.plans?.data ?? this.plans ?? [];
      if (!Array.isArray(data)) return [];

      if (this.isEditMode) {
        const isCompany = this.subscriberLocal?.subscriber_type === 'company';
        return data.filter(pl => pl.plan_active === true && Boolean(pl.plan_company) === isCompany);
      }
      return data.filter(pl => pl.plan_active === true && !pl.plan_company);
    },
    getChargesStatus() {
      return http.get(`/places/${this.place.id_place}/subscribers/charges/statuses`).then((response) => {
        this.chargesStatuses = Object.fromEntries(
          Object.entries(response.data).filter(([key, value]) => key !== 'overdue')
        );

        return response;
      });
    },
    getPaymentMethodLabel(value) {
      if (value == null || value === '') return '';
      const pm = this.paymentMethods.find(p => p.id === value);
      return pm ? pm.name : value;
    },
    async onPlanPaymentMethodChange() {
      const newValue = this.form.plan_payment_method;
      if (!this.isEditMode) {
        this.getPreviewCharges({ preserveChargePaymentMethods: false });
        return;
      }
      if (newValue === this.previousPlanPaymentMethod) return;

      const newLabel = this.getPaymentMethodLabel(newValue);
      const result = await Swal.fire({
        title: 'Confirmar alteração',
        html: `Tem certeza que deseja mudar a forma de pagamento para <strong>${newLabel}</strong>? As parcelas pendentes serão atualizadas.`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#6c757d',
      });
      if (!result.isConfirmed) {
        this.form.plan_payment_method = this.previousPlanPaymentMethod;
        return;
      }
      this.previousPlanPaymentMethod = newValue;
    },
    getPreviewCharges(options = {}) {
      const preserveChargePaymentMethods = options.preserveChargePaymentMethods !== false;
      if (this.isEditMode)
        return Promise.resolve();
      if (!this.selectedPlan?.id_plan)
        return;
      if (!this.form.plan_payment_method) {
        this.chargesPreview = [];
        return Promise.resolve();
      }

      const previousByIndex = preserveChargePaymentMethods
        ? this.chargesPreview.map((c) => c.plan_payment_method)
        : [];

      return http.get(`/places/${this.place.id_place}/subscribers/charges/preview`, {
        params: {
          id_plan: this.selectedPlan?.id_plan,
          dependents: this.form.dependents.length,
          subs_base_price: this.form.subs_base_price,
          subs_dependent_price: this.form.subs_dependent_price,
          start_date: this.form.start_date,
          first_date_due: this.form.first_date_due,
          plan_payment_method: this.form.plan_payment_method,
          billing_mode: this.form.billing_mode,
          subs_free_dependents: this.form.subs_free_dependents,
        }
      }).then((response) => {
        const rows = response.data;
        if (
          preserveChargePaymentMethods
          && Array.isArray(rows)
          && previousByIndex.length === rows.length
        ) {
          this.chargesPreview = rows.map((row, i) => ({
            ...row,
            plan_payment_method: previousByIndex[i] ?? row.plan_payment_method,
          }));
        } else {
          this.chargesPreview = rows;
        }

        return response;
      });
    },
    changeStatusAllCharges(status) {
      this.chargesPreview.forEach((item) => {
        item.charge_status = status;
      });
    },
    removeDependent(index) {
      this.form.dependents.splice(index, 1);
      this.getPreviewCharges();
    },
    addNewDependent() {
      // Verificar se é permitido adicionar dependentes
      if (!this.allowsDependents) {
        Alert.error('Este plano não permite dependentes.');
        return;
      }
      
      // Verificar limite máximo de dependentes
      if (!this.canAddMoreDependents) {
        const cap = this.dependentSlotCap;
        const label = cap === Infinity ? (this.selectedPlan.plan_max_dependents ?? 'limite do plano') : cap;
        Alert.error(`Número máximo de dependentes atingido (${label}).`);
        return;
      }

      this.form.dependents.push({});
      this.getPreviewCharges();
    },
    populateModal() {
      this.subscriberId = this.subscriberLocal?.id_subscriber;

      if (!this.subscriberId) {
        this.resetModal();
        return;
      }

      const formatDateOrNull = (value) => {
        if (value == null || value === '') return null;
        const d = this.date(value);
        return d.isValid() ? d.format('DD/MM/YYYY') : null;
      };

      this.form = {
        id_plan: this.subscriberLocal.id_plan,
        plan_payment_method: this.subscriberLocal.plan_payment_method,
        subs_base_price: this.subscriberLocal.subs_base_price ?? 0,
        subs_dependent_price: this.subscriberLocal.subs_dependent_price ?? 0,
        start_date: formatDateOrNull(this.subscriberLocal.start_date),
        first_date_due: formatDateOrNull(this.subscriberLocal.first_date_due),
        end_date: formatDateOrNull(this.subscriberLocal.end_date),
        user_name: this.subscriberLocal.user.user_name,
        ...patientIdentity(this.subscriberLocal.user),
        user_cpf: this.subscriberLocal.user.user_cpf,
        id_user: this.subscriberLocal.user.id_user,
        user_phone: this.subscriberLocal.user.user_phone,
        user_email: this.subscriberLocal.user.user_email,
        user_dt_birth: this.subscriberLocal.user.user_birthdate_br,
        subs_status: this.subscriberLocal.subs_status,
        billing_mode: this.subscriberLocal.billing_mode || 'upfront',
        subs_free_dependents: this.subscriberLocal.subs_free_dependents,
        user_address: this.subscriberLocal.user.user_address,
        user_addr_zipcode: this.subscriberLocal.user.user_addr_zipcode,
        user_addr_numer: this.subscriberLocal.user.user_addr_numer,
        user_addr_compl: this.subscriberLocal.user.user_addr_compl,
        user_neighborhood: this.subscriberLocal.user.user_neighborhood,
        id_city: this.subscriberLocal.user.id_city,
        id_state: this.subscriberLocal.user.id_state,
        dependents: (this.subscriberLocal.dependents || [])
          .filter((d) => d.dep_active !== false)
          .map((d) => {
            return {
              id_dependent: d.id_dependent,
              user_name: d.patient.patient_name,
              ...patientIdentity(d.patient),
              user_cpf: d.patient.patient_cpf,
              id_patient: d.id_patient,
              user_phone: d.patient.patient_phone,
              user_dt_birth: d.patient.patient_birthdate_br,
              dep_relationship: d.dep_relationship,
            };
          }),
      };

      this.previousPlanPaymentMethod = this.subscriberLocal.plan_payment_method;
      this.selectedPlan = this.plans.data.find(p => p.id_plan == this.subscriberLocal.id_plan);

      // Carregar cidades do estado selecionado
      if (this.form.id_state) {
        this.getCitiesFromState(this.form.id_state);
      }

      if (this.subscriberLocal.subs_base_price || this.subscriberLocal.subs_dependent_price) {
        this.$nextTick(() => {
          document.getElementById('BtnCollapseSelectedPlan')?.click();
        });
      }
    },
    onSelectPlan(planId) {
      let plan = this.plans.data.find(p => p.id_plan == planId);
      this.form.end_date = this.date().add(plan.subscriber_duration, 'months').format('DD/MM/YYYY');

      this.selectedPlan = plan;
      if (!this.isEditMode && plan) {
        this.form.subs_free_dependents = plan.plan_free_dependents ?? 0;
      }
      
      // Limpar dependentes se o plano não permitir
      if (!this.allowsDependents) {
        this.form.dependents = [];
        this.getPreviewCharges();
      }
    },
    loadPlans() {
      return http.get(`/places/${this.place.id_place}/plans`, {params: {'per_page': 1000, 'with_contract_template': true}}).then((response) => {
        this.plans = response.data;

        return response;
      });
    },
    loadPaymentMethods: function () {
      return http.get(`/places/${this.place.id_place}/plan-payment-methods`).then((response) => {
        this.paymentMethods = response.data;

        return response;
      });
    },
    loadSubscriberStatus() {
      return http.get(`/places/${this.place.id_place}/subscribers/status`).then((response) => {
        this.subscribersStatus = response.data;

        return response;
      });
    },
    loadSubscriptionConfig() {
      return http.get(`/places/${this.place.id_place}/subscription-config`).then((response) => {
        this.form.billing_mode = response.data.billing_mode || 'upfront';
        return response;
      }).catch(() => {
        // Se não houver configuração, usar padrão
        this.form.billing_mode = 'upfront';
      });
    },
    async submit() {
      const userPhone = (this.form.user_phone || '').replace(/\D/g, '');
      const userEmail = (this.form.user_email || '').trim();

      if (!userPhone) {
        Alert.error('Telefone do assinante é obrigatório.');
        return;
      }

      if (!userEmail) {
        Alert.error('E-mail do assinante é obrigatório.');
        return;
      }

      if (!this.isEditMode && !this.validateFirstDueDateNotBeforeToday()) {
        return;
      }

      if (!this.isEditMode) {
        const hasDuplicate = await this.checkDuplicateSubscription();
        if (hasDuplicate) {
          const planName = this.selectedPlan?.plan_name || 'este plano';
          const result = await Swal.fire({
            title: 'Assinatura já existente',
            html: `Este CPF já possui uma assinatura (ativa ou pendente) no plano <strong>${planName}</strong>. Deseja criar outra mesmo assim?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim, criar mesmo assim',
            cancelButtonText: 'Não',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
          });
          if (!result.isConfirmed) return;
        }
      }

      Loader.show('Salvando assinatura...', 'Por favor, aguarde.');
      
      try {
        let response = null;
        if (this.isEditMode) {
          response = await this.updateSubscriber();
        } else {
          response = await this.createSubscriber();
        }

        Loader.close();

        // Se for PIX, abrir modal de pagamento PIX
        if (!this.isEditMode && this.form.plan_payment_method === 'pix' && response?.data?.payment_details) {
          this.pixData = {
            pix_code: response.data.payment_details.pix_code,
            qr_code_base64: response.data.payment_details.pix_qrcode_img,
            payment_id: response.data.payment_details.id_card_trans,
            subscription_id: response.data.subscriber.id_subscriber,
            expires_at: response.data.payment_details.expires_at || response.data.payment_details.pix_expires_at || null,
          };
          
          this.$emit('subscriberSaved');
          this.closeModal();
          
          // Abrir modal PIX após fechar o modal de assinatura
          this.$nextTick(() => {
            this.$emit('openPixModal', this.pixData);
          });
        } else {
          Alert.success('Assinatura salva com sucesso.');
          this.$emit('subscriberSaved');
          this.closeModal();
        }
      } catch (e) {
        Loader.close();
        Alert.error(identityError(e));
      }
    },
    async checkDuplicateSubscription() {
      const cpf = this.form.document_number || (this.form.user_cpf || '').replace(/\D/g, '');
      if (!cpf || !this.selectedPlan?.id_plan) return false;
      try {
        const response = await http.get(`/places/${this.place.id_place}/subscribers`, {
          params: { search: cpf, id_plan: this.selectedPlan.id_plan, per_page: 10 },
        });
        const list = response.data?.data ?? response.data ?? [];
        const nonCancelled = Array.isArray(list) ? list.filter(s => s.subs_status !== 'cancelled') : [];
        return nonCancelled.length > 0;
      } catch {
        return false;
      }
    },
    async createSubscriber() {
      if (this.chargesPreview.length <= 0) {
        await this.getPreviewCharges();
      }

      this.form.charges = this.chargesPreview;
      return http.post(`/places/${this.place.id_place}/subscribers`, this.form);
    },
    updateSubscriber() {
      return http.put(`/places/${this.place.id_place}/subscribers/${this.subscriberId}`, this.form);
    },
    getZipCode(zipcode) {
      http.get(`zipcode/` + zipcode).then(async (response) => {
        this.form.user_address = response.data.address;
        this.form.user_neighborhood = response.data.neighborhood;
        this.form.id_state = response.data.state?.id_state;
        await this.getCitiesFromState(this.form.id_state);
        this.form.id_city = response.data.city?.id_city;

        this.$refs.user_addr_numer.focus();
      }).catch((e) => {
        console.log(e.response)
      });
    },
    getStates() {
      http.get(`/states`).then((response) => {
        this.states = response.data;
      });
    },
    getCitiesFromState(stateId) {
      if (!stateId) {
        this.citiesFromState = [];
        return Promise.resolve();
      }

      return http.get(`/states/${stateId}/cities`).then((response) => {
        this.citiesFromState = response.data;

        return response;
      });
    },
    closeModal() {
      Modal.toggle('#subscriberModal');
      this.$emit('onClose');
      this.resetModal();
    },
    resetModal() {
      this.previousPlanPaymentMethod = null;
      this.selectedPlan = null;
      this.chargesPreview = [];
      this.form = {
        subs_status: 'pending',
        start_date:  this.date().format('DD/MM/YYYY'),
        first_date_due:  this.date().format('DD/MM/YYYY'),
        id_plan: null,
        plan_payment_method: null,
        subs_base_price: 0,
        subs_dependent_price: 0,
        end_date: null,
        user_name: null,
        user_cpf: null,
        id_user: null,
        id_patient: null,
        user_phone: null,
        user_email: null,
        user_dt_birth: null,
        user_address: null,
        user_addr_zipcode: null,
        user_addr_numer: null,
        user_addr_compl: null,
        user_neighborhood: null,
        id_city: null,
        id_state: null,
        dependents: [],
        billing_mode: null,
        subs_free_dependents: null
      };
    },
    onClickSearchedPatient(patient, indexDependent = null) {
      if (indexDependent != null) {
        let dependent = this.form.dependents[indexDependent];
        dependent.patient_id = patient.id_patient;
        dependent.user_name = patient.patient_name;
        Object.assign(dependent, patientIdentity(patient));
        dependent.user_cpf = patient.patient_cpf;
        dependent.user_phone = patient.patient_phone;
        dependent.user_dt_birth = patient.patient_birthdate_formatted;

        return;
      }

      if (patient.patient_name)
        this.form.user_name = patient.patient_name;
      Object.assign(this.form, patientIdentity(patient));
      if (patient.document_type) this.form.user_cpf = null;
      if (patient.patient_cpf)
        this.form.user_cpf = patient.patient_cpf;
      if (patient.id_patient)
        this.form.id_patient = patient.id_patient;
      if (patient.id_user)
        this.form.id_user = patient.id_user;
      if (patient.patient_phone)
        this.form.user_phone = patient.patient_phone;
      if (patient.patient_email)
        this.form.user_email = patient.patient_email;
      if (patient.user_email)
        this.form.user_email = patient.user_email;
      if (patient.patient_birthdate_formatted)
        this.form.user_dt_birth = patient.patient_birthdate_formatted;

      this.getPreviewCharges();
    },
    exportCard(idDependent = null) {
      let url = `/places/${this.place.id_place}/subscribers/${this.subscriberId}/card`;
      
      if (idDependent) {
        url += `?id_dependent=${idDependent}`;
      }

      // Mostrar loader
      Swal.fire({
        title: 'Gerando carteirinha...',
        text: 'Por favor, aguarde enquanto a carteirinha é gerada.',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      http.get(url, { responseType: 'blob' })
        .then((response) => {
          // Fechar loader
          Swal.close();
          
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const blobUrl = window.URL.createObjectURL(blob);
          window.open(blobUrl, '_blank');
        })
        .catch((e) => {
          // Fechar loader
          Swal.close();
          
          Alert.error('Erro ao gerar o cartão: ' + (e.response?.data?.message || 'Erro desconhecido'));
        });
    },
    previewContract() {
      if (!this.selectedPlan?.contract_template) {
        Alert.error('Este plano não possui um modelo de contrato vinculado.');
        return;
      }

      const formData = {
        ...this.form,
        id_plan: this.selectedPlan.id_plan,
      };

      http.post(`/places/${this.place.id_place}/contract-templates/${this.selectedPlan.contract_template.id_contract_template}/preview-form`, formData)
        .then((response) => {
          this.contractPreviewHtml = response.data.html;
          this.contractPreviewTitle = this.selectedPlan.contract_template.template_name;
          Modal.toggle('#contractPreviewModalSubscriber');
        })
        .catch((e) => {
          Alert.error(e.response?.data?.message || 'Erro ao gerar pré-visualização do contrato');
        });
    },
    closeContractPreview() {
      Modal.toggle('#contractPreviewModalSubscriber');
      this.contractPreviewHtml = null;
      this.contractPreviewTitle = null;
    },
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
